// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__QH6AB","reportBodyText":"style__reportBodyText__0SPqc"};